__turbopack_context__.v({
  "followLink": "FollowArtistButton-module-scss-module__ObmfPa__followLink",
});
